<template lang="html">
    <div class="content">
        <template>
            <!-- open modal with loading the time that the pdf is generated -->
            <div class="loader">
                <img src="../../../assets/img/grid_loader.svg" />
                <p>Génération du compte rendu en cours</p>
            </div>

        </template>
    </div>
</template>

<script>
    export default {
        props: {
            params: {
                required: false,
            }
        },
        data() {
            return {
                title:          'Création d\'une fiche produit',
                icon:           'sync',
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                this.onClose()
            }
        },
        mounted(){
            this.$eventHub.$emit('hide-modal-actions')

            let downloadLink = document.createElement('A');
            this.axios.get(`/api/test-pdf/${this.params.id}`, {
                responseType: 'blob'
            })
            .then(response => {
                this.onClose()
                const data = window.URL.createObjectURL(response.data)
                // window.open(data)

                downloadLink.href = data
                downloadLink.download = "controle_"+this.$store.state.single.data.code+".pdf";
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink)
            })
        }

    }
</script>

<style lang="stylus" scoped>
    div.content
        padding 1rem 4rem

    .loader
        display flex
        flex-direction column
        align-items center
        width 100%
        padding 3rem 0

        img
            margin 0 0 3rem

</style>



// WEBPACK FOOTER //
// src/views/products/single/TestPDF.vue